import PromisingCreditLines from './PromisingCreditLines';
import MembershipSourceCard from './MembershipSourceCard';
import BenefitReportsPanel from './BenefitReportsPanel';
import SubscribedVisitModal from './SubscribedVisitModal';
import PayPalSubscribeOverlay from './PayPalSubscribeOverlay';
import PlatformFooter from '../appComponents/mobile/PlatformFooter';
import PlatformHeader from '../appComponents/mobile/PlatformHeader';
import MobileViewport from '../appComponents/mobile/MobileViewport';
import { switchPlatformTheme } from '../appComponents/shared/ThemePreference';
import '../appComponents/shared/css/PlatformExperience.css';
import './css/SubscriptionCarouselRefinement.css';
import MobileOverlayStyles from '../appComponents/mobile/MobileOverlayStyles';
import PageLoading from '../appComponents/shared/PageLoading';
import { trackPageRequest } from '../appComponents/shared/PageLoadingService';
import '../appComponents/shared/crypto/css/OverlayTheme.css';
import { authenticatedPut } from '../appComponents/shared/AuthenticatedAPI';
import React, { Component } from 'react';

import '../appComponents/mobile/css/MobileExperience.css';
import '../appComponents/mobile/css/MobileDeviceWidth.css';
import '../appComponents/mobile/css/MobileResponsiveViewport.css';

import '../appComponents/mobile/css/MobileDeviceWidthGuard.css';
import '../appComponents/mobile/css/MobileConsolidated.css';
import '../appComponents/mobile/css/MobileScrollAndBenefits.css';
import './css/SubscriptionPlanMobileRedesign.css';
class SubscriptionPlanMobileRender extends Component {
  render() {
    const { getMembershipIdentity, API, AWS, Amplify, Auth, Bar, Button, ButtonContent, ButtonGroup, CartesianGrid, Chart, Component, Container, Form, FormField, Fragment, Header, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, Legend, Line, LineChart, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, PutObjectCommand, Radio, React, ResponsiveContainer, S3Client, Storage, SubscriptionPlan, ThreeDot, Tooltip, Web3, XAxis, YAxis, actionText, awsconfig, axios, blenderCommissionPublicKey, blenderPrivateKey, blenderTransfersToPublicKey, buttonColorFlashIntervalDefault, buttonText, checkValidAuthTokenIntervalPeriod_ms, cognitoID, corporateBackedUsernamesArray, costText, currentUser, currentUserCap, emailAddress, ethers, fileDialog, firstName, fundWalletPromptDidBool, initialSubscriberBoolStatus, isMobile, isSubscribedCurrentBool, lastName, managerDisplay, managerUsername, mimemessage, mode_light_dark, monthLengtheningEnum, navigationHandler, primaryDisplayCurrency, primaryLanguage, publicKey, region, routeProps, secondaryDisplayCurrency, secretName, that, tokenLifeTimeLimit, transactionValue, useLayoutEffect, useParams, useRef, web3 } = this.props;

    return (
(
          <div className={"pageBody tbp-platform tbp-platform--" + (that.state.mode_light_dark === 'light' ? 'light' : 'dark') + " tbp-platform--subscription-plan tbp-platform--mobile tbp-mobile-redesign"}>
              <SubscribedVisitModal open={Boolean(that.state.showSubscribedVisitModal)} onClose={() => that.setState({ showSubscribedVisitModal: false })} spanish={that.state.selectedLanguage === 'spanish'} theme={that.state.mode_light_dark} />
<MobileViewport />
<MobileOverlayStyles />

              <PageLoading theme={that.state.mode_light_dark} language={that.state.selectedLanguage} busy={Boolean(that.state.freezeButtonsBool || that.state.activityIndicator === true)} />

            
            <head>
              <script src="https://www.gstatic.com/charts/loader.js"></script>
            </head>


              <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.errorTags}
// open={true}
style={{
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}>
                  <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                      
                      <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                          The Blender Platform
                      </p>
                  </Modal.Header>
                  
                  <Modal.Content image style={{
    justifyContent: 'space-between',
    marginBottom: 0,
    height: 'auto',
    width: '100%',
    position: 'static',
    margin: 0,
    lineHeight: 1.5,
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                      
                      <Modal.Description style={{
      width: '100%',
      height: 'auto',
      position: 'static',
      margin: 0,
      lineHeight: 1.5
    }}>
                          <Header style={{
        // left: '16vw',
        fontSize: 17,
        // position: 'absolute',
        overflowY: 'hidden',
        overflowX: 'hidden',
        width: '100%',
        marginBottom: 0,
        paddingRight: 16,
        height: 'auto',
        position: 'static',
        margin: 0,
        lineHeight: 1.5
      }}>
                              <p style={{
          textAlign: 'left',
          textWrap: 'wrap',
          fontWeight: '600',
          fontSize: 16,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                              {that.state.selectedLanguage == 'spanish' ? 'Error:' : 'Error:'}
                              </p>
                              <p style={{
          textAlign: 'left',
          textWrap: 'wrap',
          fontWeight: '600',
          fontSize: 16,
          marginRight: 0,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                              {that.state.errorTags}
                              </p>
                          </Header>
                      
                          <Button content={that.state.selectedLanguage == 'spanish' ? 'Bueno' : 'Okay'}
      // labelPosition='right'
      // icon='checkmark'
      onClick={() => {
        that.setState({
          successfulDepositOverlay: false,
          errorTags: null
        });
      }} positive style={{
        backgroundColor: 'rgba(0, 158, 129, 1)',
        // left: '0vw',
        borderRadius: 3,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        marginLeft: 0,
        marginRight: 0,
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }} />
                      </Modal.Description>
                  </Modal.Content>
              </Modal>

              <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.uploadDocumentOverlay}
// open={true}
style={{
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
                                      
                <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                    
                    <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                        The Blender Platform
                    </p>
                </Modal.Header>

                <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                  
                  <Modal.Description style={{}}>
                    <Header style={{
        fontSize: 16,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        paddingRight: 16,
        height: 'auto',
        width: '100%',
        margin: 0,
        lineHeight: 1.5
      }}>
                      {that.state.documentDetails}  
                    </Header>
                    
                    <div style={{
        flexDirection: 'row',
        justifyContent: 'center',
        padding: 15,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%'
      }}>
                      <Button content="Close" labelPosition='right' icon='close' onClick={() => {
          that.setState({
            uploadDocumentOverlay: false
          });
        }} positive style={{
          backgroundColor: 'rgba(204, 12, 12, 1)',
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          marginLeft: 0,
          minHeight: 44,
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
        }} />
                      <Button content="Upload" labelPosition='right' icon='upload' onClick={() => {
          that.uploadNewVRDocument(that.state.documentName);
        }} positive style={{
          backgroundColor: 'rgba(0, 158, 129, 1)',
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          minHeight: 44,
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
        }} />
                    </div>
                  </Modal.Description>
                
                  
                </Modal.Content>
                
              </Modal>
              
              <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={'tbp-mobile-navigation ' + (that.state.mode_light_dark == 'light' ? 'light' : 'dark') + ' tbp-mobile-dialog'} open={that.state.navigationOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
                <div className="tbp-mobile-menu-panel" style={{
    // borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '8vh',
    borderRightStyle: 'solid',
    borderWidth: 0.1,
    borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
    padding: '20px',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
    border: 0,
    boxSizing: 'border-box',
    position: 'static',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    width: '100%'
  }}><div style={{
      justifyContent: "space-between",
      marginBottom: 24,
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      margin: '0 0 20px',
      width: '100%'
    }} className={'tbp-menu-header'}><div style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        textAlign: 'left',
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        maxWidth: '100%',
        flex: 1,
        padding: 0,
        margin: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        width: 'auto',
        minWidth: 0
      }} className={'tbp-menu-brand'}> 
                    <div style={{
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 12,
          width: 'auto',
          minWidth: 0
        }}>
                      <img src={'https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png'} style={{
            left: '4vw',
            paddingRight: '2vw',
            // position: 'absolute',
            borderRadius: '0.5',
            weight: '3vh',
            position: 'static',
            flexShrink: 0,
            width: 28,
            height: 28,
            flex: '0 0 28px',
            padding: 0,
            margin: 0
          }} />
                      <p style={{
            textAlign: 'left',
            // marginBottom: 5,
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: 0,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            flex: 1,
            minWidth: 0,
            width: 'auto',
            fontSize: 16,
            lineHeight: 1.4,
            overflowWrap: 'normal',
            wordBreak: 'normal',
            margin: 0
          }}>
                        {'The Blender Platform'}
                        <span className="tbp-menu-username" title={String(currentUser || that.state.currentUser || '')}>{'@' + String(currentUser || that.state.currentUser || '').replace(/^@/, '')}</span>
                      </p>
                    </div>

                  </div><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        flexShrink: 0,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        minHeight: 44,
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        maxWidth: '100%',
        width: 44,
        height: 44,
        flex: '0 0 44px',
        padding: 0,
        margin: 0
      }} onClick={() => {
        that.setState({
          navigationOverlay: false
        });
      }}> 
                    <svg className="tbp-mobile-menu-close-svg" aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 5L19 19M19 5L5 19" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" /></svg>
                  </Button></div><List className="tbp-mobile-menu-list" style={{
      justifyContent: 'space-between',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      alignItems: 'stretch',
      height: 'auto',
      width: '100%',
      marginTop: 0,
      marginBottom: 0,
      paddingLeft: 16
    }}>
                    <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                      <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button" onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/home'
            }
          });
        }}>
                        <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                          <i className="home icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }} />
                          &nbsp;
                          {that.state.selectedLanguage == 'spanish' ? 'Activos' : 'Accounts'}
                        </p>
                      </button>
                    </ListItem>
                    <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                      <button onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/browser'
            }
          });
        }} style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button">
                        <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                          <i className="search icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                          &nbsp;
                          {that.state.selectedLanguage == 'spanish' ? 'Buscar' : 'Browse'}
                        </p>
                        
                      </button>
                    </ListItem>

                    <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                      <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/newborrowingacct'
            }
          });
        }} className="ui huge teal button">
                        <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                          <i className="newspaper icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                          &nbsp;
                          {that.state.selectedLanguage == 'spanish' ? 'Tomar Prestamo' : 'Borrow Funds'}
                        </p>
                        
                      </button>
                    </ListItem>
                    <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                      <button onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/membertransactions'
            }
          });
        }} style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button">
                        <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                          <i className="wait icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                          &nbsp;
                          {that.state.selectedLanguage == 'spanish' ? 'Transacciones' : 'Transactions'}
                        </p>
                        
                      </button>
                    </ListItem>
                    <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                      <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false
          });
        }} className="ui huge teal button">
                        <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                          <i className="star icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                          &nbsp;  
                          {'Blender Pro Plus'}
                        </p>
                        
                      </button>
                    </ListItem>
                    <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                      <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/accountmanagement'
            }
          });
        }} className="ui huge teal button">
                        <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                          <i className="star icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                          &nbsp;  
                          {'Profile'}
                        </p>
                        
                      </button>
                    </ListItem>
                    <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                      <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          var win = window.open('https://lenderblock.io/termsandconditions-tbp', '_blank');
          win.focus();
        }} className="ui huge teal button">
                        <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                          <i className="book icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                          &nbsp;
                          {that.state.selectedLanguage == 'spanish' ? 'Condiciones' : 'Terms of Use'}
                        </p>
                        
                      </button>
                    </ListItem>
                    <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                      <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          var win = window.open('https://lenderblock.io/privacypolicy-tbp', '_blank');
          win.focus();
        }} className="ui huge teal button">
                        <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                          <i className="book icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                          &nbsp;
                          {that.state.selectedLanguage == 'spanish' ? 'Privacidad' : 'Privacy Policy'}
                        </p>
                        
                      </button>
                    </ListItem>
                  </List><div className="tbp-mobile-menu-actions" style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      borderTop: "1px solid rgba(128,128,128,.25)",
      marginTop: 24,
      paddingTop: 12
    }}><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        width: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%'
      }} onClick={() => {
        trackPageRequest(Auth.signOut());
        that.setState({
          navigationDestinationObject: {
            navigationRoute: '/welcome'
          }
        });
      }}> 
                    <p style={{
          textAlign: 'left',
          fontSize: 16,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          margin: 0,
          width: '100%'
        }}>
                      <i className="sign out icon" style={{
            position: 'static',
            fontSize: 20,
            height: 20,
            lineHeight: 1,
            flexShrink: 0,
            flex: '0 0 22px',
            width: 22,
            margin: 0
          }} />
                      {that.state.selectedLanguage == 'spanish' ? 'Desconectar' : 'Sign Out'}
                    </p>
                  </Button><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        width: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%'
      }} onClick={() => switchPlatformTheme({ that, authenticatedPut, currentUser })}>
                    <i style={{
          zIndex: 999,
          textAlign: 'left',
          textAlignVertical: 'top',
          // marginBottom: 0, 
          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)'
          // marginLeft: 5,
          ,

          position: 'static',
          fontSize: 20,
          margin: 0,
          width: 20,
          height: 20,
          lineHeight: 1,
          flexShrink: 0
        }} className={that.state.mode_light_dark == 'dark' ? "sun icon" : "moon icon"} />
                  </Button></div></div>
              </Modal>  
              

              <div className="tbp-platform__workspace tbp-pro-v55-workspace">
                <PlatformHeader
                  title={'Blender Pro Plus'}
                  language={that.state.selectedLanguage}
                  onHome={() => that.setState({ navigationDestinationObject: { navigationRoute: '/home' } })}
                  onMenu={() => that.setState({ navigationOverlay: true })}
                />

                <main className="tbp-platform__body tbp-pro-v55-body">
                  <div className="tbp-pro-v55-scroll">
                    <div className="tbp-pro-v55-inner">
                      <section className="tbp-pro-v55-status-card" aria-label={that.state.selectedLanguage === 'spanish' ? 'Membresía' : 'Membership'}>
                        <div className="tbp-pro-v55-kicker">
                          <i className="diamond icon" aria-hidden="true" />
                          {that.state.selectedLanguage === 'spanish' ? 'MEMBRESÍA' : 'MEMBERSHIP'}
                        </div>
                        <h1>{that.state.selectedLanguage === 'spanish' ? 'Blender Pro Plus' : 'Blender Pro Plus'}</h1>
                        <div className={'tbp-pro-v55-status ' + (that.state.isSubscribedCurrentBool ? 'tbp-pro-v55-status--active' : '')}>
                          <i className={(that.state.isSubscribedCurrentBool ? 'check circle' : 'info circle') + ' icon'} aria-hidden="true" />
                          <span>{that.state.isSubscribedCurrentBool
                            ? (that.state.selectedLanguage === 'spanish' ? 'Suscripción activa' : 'Active subscription')
                            : (that.state.selectedLanguage === 'spanish' ? 'No tienes una suscripción activa' : 'No active subscription')}
                          </span>
                        </div>
                        <p className="tbp-pro-v55-summary">{that.state.isSubscribedCurrentBool
                          ? (that.state.selectedLanguage === 'spanish'
                            ? 'Aprovecha los beneficios de Blender Pro Plus.'
                            : 'Enjoy your Blender Pro Plus membership benefits.')
                          : (that.state.selectedLanguage === 'spanish'
                            ? 'Suscríbete a Blender Pro Plus para acceder a los beneficios exclusivos.'
                            : 'Join Blender Pro Plus to unlock member benefits.')}
                        </p>
                        {that.state.isSubscribedCurrentBool && <div className="tbp-pro-membership-summary tbp-pro-membership-summary--mobile">
                          <MembershipSourceCard membership={that.state.membership} active={true} spanish={that.state.selectedLanguage === 'spanish'} />
                        </div>}
                        {!that.state.isSubscribedCurrentBool && (
                          <PayPalSubscribeOverlay language={that.state.selectedLanguage} theme={that.state.mode_light_dark} mobile={true} disabled={Boolean(that.state.disableButtons || that.state.freezeButtonsBool)}
                          getAccountId={async () => (await getMembershipIdentity()).userId}
                          onApproved={(subscriptionId) => that.onPayPalSubscriptionApproved(subscriptionId)} />
                        )}
                      </section>


                      <section className="tbp-pro-v55-benefits-section" style={{ width: '100%', marginTop: 16, marginBottom: 6 }}>
                        <BenefitReportsPanel getMembershipIdentity={getMembershipIdentity} active={Boolean(that.state.isSubscribedCurrentBool)} spanish={that.state.selectedLanguage === 'spanish'} platformBenefits={that.state.subscriberBenefitsArray} memberProfile={that.state.memberPdfProfile || { username: that.state.currentUser || '' }} />
                      </section>

                      <section style={{width:'100%',marginTop:14}}><PromisingCreditLines getMembershipIdentity={getMembershipIdentity} active={Boolean(that.state.isSubscribedCurrentBool)} spanish={that.state.selectedLanguage === 'spanish'} /></section>

                    </div>
                    <PlatformFooter language={that.state.selectedLanguage} mobile className="tbp-subscription-mobile-footer" />
                  </div>
                </main>
              </div>
          </div>
        )
    );
  }
}

export default SubscriptionPlanMobileRender;
